import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/role/list',
        method: 'get',
        params: query
    })
}
